module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAKCAYAAADsKu3/AAAABGdBTUEAALGPC/xhBQAAALtJREFUSA3dlVEKwjAQRNtK7+EBPILgh/QExZMK/vVDegVvo9DO1I3dhCX/48A2m9nMx6MlbReoyfW07SW3qzu5TBuAXw1xqqLmQ70MwZ3mxANvdn6tlcw0ILqjBtQR1TnwzjzOeMZLPkPwN+qWgMuVMzuD5Sf5DMGpD2oMoEeb8Uwp6Uz6tA+APpXg5nEWSTqTwAn24gOv9cxiD23etw2fshkP3gP4ATze0rzR2fch7m7KZqL/+I71x90KgegFu202aBEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Content/images/combined_stars.png
// module id = Z9TY
// module chunks = 1